<template>
  <c-text
    :aria-label="ariaLabel"
    :class="['price', '--price-' + variation]"
    :text-align="align"
    white-space="normal"
  >
    <span v-if="label" class="price__label">{{ label }}</span>
    <c-text
      as="span"
      v-if="hasCampaignPrice"
      class="price__value price__value--campaign"
      color="brand.greenDark"
      font-weight="bold"
    >
      {{
        roundToCents(campaignPrice, true)
          | currency(
            symbol,
            thousandsSeparator,
            fractionCount,
            fractionSeparator,
            symbolPosition,
            symbolSpacing
          )
      }}
      <br />
    </c-text>
    <c-text
      as="span"
      class="price__value price__value--old"
      :font-size="hasCampaignPrice && 'sm'"
      :text-decoration="hasCampaignPrice && 'line-through'"
      :color="(hasCampaignPrice && 'brand.purple') || 'black'"
    >
      {{
        roundToCents(price)
          | currency(
            symbol,
            thousandsSeparator,
            fractionCount,
            fractionSeparator,
            symbolPosition,
            symbolSpacing
          )
      }}
    </c-text>
  </c-text>
</template>

<script>
import { CText } from "@chakra-ui/vue";
import { roundToCents } from "@/util/PriceUtil";

const cfgByCurrency = {
  USD: {
    symbol: "$",
    thousandsSeparator: ",",
    fractionCount: 2,
    fractionSeparator: ".",
    symbolPosition: "front",
    symbolSpacing: true,
  },
  EUR: {
    symbol: "€",
    thousandsSeparator: " ",
    fractionCount: 2,
    fractionSeparator: ",",
    symbolPosition: "end",
    symbolSpacing: true,
  },
  SEK: {
    symbol: "kr",
    thousandsSeparator: " ",
    fractionCount: 2,
    fractionSeparator: ",",
    symbolPosition: "end",
    symbolSpacing: true,
  },
  NOK: {
    symbol: "kr",
    thousandsSeparator: " ",
    fractionCount: 2,
    fractionSeparator: ",",
    symbolPosition: "end",
    symbolSpacing: true,
  },
  DKK: {
    symbol: "kr.",
    thousandsSeparator: " ",
    fractionCount: 2,
    fractionSeparator: ",",
    symbolPosition: "end",
    symbolSpacing: true,
  },
  GBP: {
    symbol: "£",
    thousandsSeparator: ",",
    fractionCount: 2,
    fractionSeparator: ".",
    symbolPosition: "front",
    symbolSpacing: false,
  },
  CAD: {
    symbol: "$",
    thousandsSeparator: " ",
    fractionCount: 2,
    fractionSeparator: ",",
    symbolPosition: "end",
    symbolSpacing: true,
  },
};

export default {
  name: "Price",
  hideFromDocs: true,
  status: "prototype",
  release: "0.0.1",
  components: {
    CText,
  },
  props: {
    /**
     * Price variation
     * `grid`,`list`
     */
    variation: {
      type: String,
      default: "list",
      validator: (value) => {
        return value.match(/(grid|list)/);
      },
    },
    /**
     * Price
     */
    align: {
      type: String,
      default: "left",
      validator: (value) => {
        return value.match(/(left|right)/);
      },
    },
    /**
     * Price
     */
    price: {
      type: Number,
      required: true,
    },
    /**
     * Price label
     */
    label: {
      type: String,
      required: false,
      default: "",
    },
    /**
     * Aria label
     */
    ariaLabel: {
      type: String,
      default: "",
    },
    /**
     * Campaign Price
     */
    // eslint-disable-next-line vue/require-default-prop
    campaignPrice: {
      type: Number,
    },
    /**
     * Currency code
     */
    // eslint-disable-next-line vue/require-default-prop
    currency: {
      type: String,
      required: false,
    },
  },
  methods: {
    roundToCents(value, isCampaignPrice) {
      return roundToCents(value, isCampaignPrice);
    },
  },
  data() {
    return {
      hasCampaignPrice: this.campaignPrice || this.campaignPrice === 0 ? true : false,
      symbol:
        this.currency && cfgByCurrency[this.currency]
          ? cfgByCurrency[this.currency].symbol
          : this.currency,
      thousandsSeparator:
        this.currency && cfgByCurrency[this.currency]
          ? cfgByCurrency[this.currency].thousandsSeparator
          : " ",
      fractionCount:
        this.currency && cfgByCurrency[this.currency]
          ? cfgByCurrency[this.currency].fractionCount
          : 2,
      fractionSeparator:
        this.currency && cfgByCurrency[this.currency]
          ? cfgByCurrency[this.currency].fractionSeparator
          : ",",
      symbolPosition:
        this.currency && cfgByCurrency[this.currency]
          ? cfgByCurrency[this.currency].symbolPosition
          : "end",
      symbolSpacing:
        this.currency && cfgByCurrency[this.currency]
          ? cfgByCurrency[this.currency].symbolSpacing
          : true,
    };
  },
};
</script>
